module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8460/img/iphone-frame.png"